import { render, staticRenderFns } from "./GroupDictionaryItem.vue?vue&type=template&id=4ff90f3a&scoped=true&"
import script from "./GroupDictionaryItem.vue?vue&type=script&lang=js&"
export * from "./GroupDictionaryItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupDictionaryItem.vue?vue&type=style&index=0&id=4ff90f3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff90f3a",
  null
  
)

export default component.exports